<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mt-5 cursor-pointer" :class="{show: expanded}" @click="toggle">
            <h3>Wachtwoord wijzigen</h3>
            <i class="far fa-angle-down lead"></i>
        </div>
        <transition-slide-toggle>
            <form @submit.prevent="submit" novalidate v-show="expanded" class="accordion-body">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.password.$error}">
                            <label for="password-5bc4960" class="control-label">Wachtwoord</label>
                            <input type="password" id="password-5bc4960" class="form-control" v-model.trim.lazy="$v.form.password.$model">
                            <div class="help-text" v-if="$v.form.password.$error">
                                <p v-if="!$v.form.password.required">Dit veld is verplicht</p>
                                <p v-if="!$v.form.password.password">{{ passwordDescription }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.repeatPassword.$error}">
                            <label for="password-confirm-5bc4960" class="control-label">Wachtwoord herhalen</label>
                            <input type="password" id="password-confirm-5bc4960" class="form-control" v-model.trim.lazy="$v.form.repeatPassword.$model">
                            <div class="help-text" v-if="$v.form.repeatPassword.$error">
                                <p v-if="!$v.form.repeatPassword.sameAsPassword">De wachtwoorden komen niet overeen</p>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary btn-caret btn-sm mr-4 mb-3 mb-md-0" ref="btn">Gegevens aanpassen</button>
            </form>
        </transition-slide-toggle>
    </div>
</template>

<script>
    import {required, sameAs} from 'vuelidate/lib/validators'
    import password from '../js/validators/passwordComplexity'

    export default {
        props: {
            data: Object,
            passwordDescription: String,
            btnStartLoading: Function,
            btnFinishLoading: Function,
        },
        data() {
            return {
                expanded: false,
                form: {
                    password: null,
                    repeatPassword: null,
                },
            }
        },
        validations: {
            form: {
                password: {
                    required,
                    password,
                },
                repeatPassword: {
                    sameAsPassword: sameAs('password'),
                },
            }
        },
        methods: {
            submit() {
                this.$refs.btn.blur();
                this.$v.$touch();

                if (this.$v.$anyDirty && !this.$v.$invalid) {
                    this.btnStartLoading(this.$refs.btn);

                    let that = this;
                    this.axios.post('/users/password', this.form).then(() => {
                        that.form.password = '';
                        that.form.repeatPassword = '';

                        that.$notify({
                            group: 'base',
                            text: 'Het wachtwoord is gewijzigd. Log de volgende keer in met uw nieuwe wachtwoord.',
                            type: 'alert-info',
                        });

                        this.btnFinishLoading(this.$refs.btn, true);
                    }).catch(error => {
                        that.$notify({
                            group: 'base',
                            text: 'Er is een fout opgetreden.',
                            type: 'alert-danger',
                        });

                        that.btnFinishLoading(this.$refs.btn);

                        console.error(error);
                    });
                }
            },
            toggle() {
                this.expanded = !this.expanded;
            },
        }
    }
</script>
